import _Select from "@material-ui/core/esm/Select";
import { styled, withStyles } from '@material-ui/core/styles';
const Select = withStyles({
  root: {
    height: '56px',
    backgroundColor: '#fafafa',
    color: '#acadad',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '15px',
    fontSize: '15px',
    lineHeight: '26px',
    width: '100%',
    boxSizing: 'border-box'
  },
  select: {
    width: '100%',
    '&:focus': {
      backgroundColor: 'transparent'
    }
  },
  icon: {
    margin: '0 5px',
    color: '#d8d8d8'
  }
})(styled(_Select)({
  '&:after': {
    display: 'none'
  },
  '&:before': {
    display: 'none'
  }
}));
export default Select;